import { css, type DefaultTheme, type FlattenInterpolation, type ThemeProps } from 'styled-components';
import type { AlertProps } from '../Alert';

export const getAlertStyleByType = (type: AlertProps['type']): FlattenInterpolation<ThemeProps<DefaultTheme>> => {
  switch (type) {
    case 'info':
      return css`
        background-color: ${({ theme }) => theme.color.semantic.feedback.background.info};
      `;
    case 'success':
      return css`
        background-color: ${({ theme }) => theme.color.semantic.feedback.background.success};
      `;
    case 'warning':
      return css`
        background-color: ${({ theme }) => theme.color.semantic.feedback.background.warning};
      `;
    case 'error':
      return css`
        background-color: ${({ theme }) => theme.color.status.backgroundFill.error};
      `;
    default:
      return css`
        background-color: ${({ theme }) => theme.color.semantic.feedback.background.info};
      `;
  }
};
